import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import onClickOutside from "react-onclickoutside";

import TwoLabelSwitch from "../Switch/TwoLabelSwitch";

class SortItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      sortOrder: this.getInitialSortOrder()
    };
  }

  getInitialSortOrder = () => {
    if (this.isSelected() && this.props.sortOrder == "asc") {
      return "asc";
    }

    return "desc";
  };

  handleClickOutside = () => {
    this.setState({ open: false });
  };

  getSelectedItem = () => {
    return this.props.options.find(option => {
      return option.value == this.props.sortBy;
    });
  };

  getSelectedName = () => {
    let selected = this.getSelectedItem();

    if (!selected) {
      selected = this.props.options[0];
    }

    return selected.name_short;
  };

  getSortOrder = () => {
    return this.state.sortOrder == "asc" ? "asc" : "desc";
  };

  isSelected = () => {
    return this.getSelectedItem() != undefined;
  };

  isAsc = () => {
    return this.state.sortOrder == "asc" && this.isSelected();
  };

  isDesc = () => {
    return !this.isAsc() && this.isSelected();
  };

  open = () => {
    this.setState({ open: true });
  };

  switchAsc = e => {
    let sortOrder = "asc";
    if (e.target.checked) {
      sortOrder = "desc";
    }

    this.props.onChange({ sortBy: this.props.sortBy, sortOrder });

    this.setState({ sortOrder });
  };

  switchSortBy = sortBy => {
    this.props.onChange({ sortBy, sortOrder: this.getSortOrder() });
    this.setState({ open: false });
  };

  render() {
    return (
      <div
        className={classnames("sort-group__item-container", {
          active: this.isSelected(),
          open: this.state.open
        })}
      >
        <div
          onClick={this.open}
          className={classnames("sort-group__item", {
            active: this.isSelected(),
            "sort-asc": this.isAsc(),
            "sort-desc": this.isDesc()
          })}
        >
          {this.getSelectedName()}
        </div>

        {this.state.open && (
          <div className="sort-group__item-options">
            {this.props.options.map(option => (
              <div
                className={classnames("sort-group__sort-item", {
                  active: option.value == this.props.sortBy
                })}
                onClick={() => this.switchSortBy(option.value)}
              >
                {option.name}
              </div>
            ))}

            <div className="sort-group__order-section">
              <TwoLabelSwitch
                labelOn={"От большего"}
                labelOff={"От меньшего"}
                size="small"
                checked={this.state.sortOrder != "asc"}
                onChange={this.switchAsc}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

SortItem.propTypes = {
  options: PropTypes.array,
  sortOrder: PropTypes.string,
  sortBy: PropTypes.string,
  onChange: PropTypes.func
};

export default onClickOutside(SortItem);
